import VerificationConfirmed from './VerificationConfirmed'
export default VerificationConfirmed